





















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import UITabItemComponent from "./ui-tab-item.vue";

@Component({
  name: "ui-tabs"
})
export default class UITabsComponent extends Vue {
  @Prop({ default: true, type: Boolean })       gaphOn!: Boolean;
  @Prop({ default: null, type: Boolean })         right: Boolean;
  @Prop({ default: 15,   type: Number })   titlePadding: Number;
  
  arr: any[] = [];

  get childTabs(): UITabItemComponent[] {
    return this.$children.filter(
      el => el instanceof UITabItemComponent
    ) as UITabItemComponent[];
  }

  mounted() {
    this.arr = this.childTabs;
  }
  onClickTab(value: any, index:number) {
    // this.arr.filter(x=>x.)
    if (this.arr[index].isDisabled) return;
    var i=0;
    this.arr.forEach(tab => {
        if (i==index) tab.setActive(true)
        else tab.setActive(false)
        i++;
    });
    this.$emit("click", value, index);
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-tabs/src/ui-tabs.vue